import { formatRelative, parseISO } from "date-fns";
import AvatarButton from "../../fragments/AvatarButton";

const ChatMessage = ({ user, timestamp, message, is_system, is_private }) => {
  const datetime = parseISO(timestamp);

  return (
    <div className="flex items-start gap-x-2 px-2 py-1 group hover:bg-gray-200">
      <AvatarButton user={user} isSystem={is_system} />
      <div>
        <div className="flex items-center">
          {is_system ? (
            <span className="font-medium text-primary-600">TriviaRoyale</span>
          ) : (
            <span className="font-medium hover:decoration-2">
              {user.username}
            </span>
          )}
          {is_system ? (
            <span
              className={`ml-2 mr-1 px-1.5 py-0.5 text-xs bg-primary-50 text-primary-800 border border-primary-800 rounded-md`}
            >
              {gettext("System Message")}
            </span>
          ) : (
            user.label && (
              <span
                className={`ml-2 mr-1 px-1.5 py-0.5 text-xs bg-${user.label.color}-50 text-${user.label.color}-800 border border-${user.label.color}-800 rounded-md`}
              >
                {user.label.text}
              </span>
            )
          )}
          {is_private ? (
            <span className="ml-1 text-gray-300 group-hover:text-gray-400">
              {gettext("(only you see this message)")}
            </span>
          ) : (
            <time className="ml-1 text-gray-300 group-hover:text-gray-400">
              {formatRelative(datetime, new Date(), "eeee")}
            </time>
          )}
        </div>
        <div>
          {message.map((line, i) => (
            <p key={i} className="my-1">
              {line}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
export default ChatMessage;
